import React, { useRef, useEffect } from 'react';
import {
  Attachment,
  Avatar,
  messageHasReactions,
  MessageOptions,
  MessageStatus,
  MessageText,
  MessageTimestamp,
  ReactionSelector,
  SimpleReactionsList,
  useMessageContext,
} from 'stream-chat-react';
import { FiPaperclip, FiClock, FiUser } from 'react-icons/fi';

import './CustomMessage.css';
export const CustomMessage = () => {
  const {
    isReactionEnabled,
    message,
    reactionSelectorRef,
    showDetailedReactions,
    handleCloseReactionSelector,
  } = useMessageContext();

  const messageWrapperRef = useRef(null);
  const reactionWrapperRef = useRef(null);
  const leaveTimeoutRef = useRef(null);

  const hasReactions = messageHasReactions(message);
  const hasAttachments = message.attachments && message.attachments.length > 0;

  useEffect(() => {
    if (!showDetailedReactions) return;

    // Wait a bit for the selector to render
    const setupTimer = setTimeout(() => {
      const reactionSelector = document.querySelector('.str-chat__reaction-selector');

      if (!reactionSelector) return;

      const handleMouseLeave = () => {
        // Add small delay to prevent accidental closes
        leaveTimeoutRef.current = setTimeout(() => {
          // Simulate a click on document to trigger Stream Chat's close mechanism
          const mouseDownEvent = new MouseEvent('mousedown', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          document.dispatchEvent(mouseDownEvent);

          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          document.dispatchEvent(clickEvent);
        }, 200);
      };

      const handleMouseEnter = () => {
        // Cancel close if mouse comes back
        if (leaveTimeoutRef.current) {
          clearTimeout(leaveTimeoutRef.current);
          leaveTimeoutRef.current = null;
        }
      };

      reactionSelector.addEventListener('mouseleave', handleMouseLeave);
      reactionSelector.addEventListener('mouseenter', handleMouseEnter);

      return () => {
        if (leaveTimeoutRef.current) {
          clearTimeout(leaveTimeoutRef.current);
        }
        reactionSelector.removeEventListener('mouseleave', handleMouseLeave);
        reactionSelector.removeEventListener('mouseenter', handleMouseEnter);
      };
    }, 50);

    return () => {
      clearTimeout(setupTimer);
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
  }, [showDetailedReactions, handleCloseReactionSelector]);

  return (

    <div className='message-wrapper'>
      <Avatar image={message.user?.image} />
      <div className='message-wrapper-content'>
        <div className='message-header'>
          <div className='message-header-name'>
            <FiUser style={{ marginRight: '6px' }} />
            {message.user?.name}
          </div>
          <div className='message-header-timestamp'>
            <FiClock style={{ marginRight: '4px' }} />
            <MessageTimestamp />
          </div>
        </div>
        <MessageText />
        {hasAttachments && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <FiPaperclip />
            <Attachment attachments={message.attachments} />
          </div>
        )}
        <MessageOptions messageWrapperRef={messageWrapperRef} />
        {showDetailedReactions && isReactionEnabled && (
          <div ref={reactionWrapperRef}>
            <ReactionSelector ref={reactionSelectorRef} />
          </div>
        )}
        <MessageStatus />
        {hasReactions && !showDetailedReactions && isReactionEnabled && <SimpleReactionsList />}

      </div>
    </div>
  );
};
